import { colors } from '../../common/colors';

const theme = {
  primary:           '#696969',
  secondary:         '#FF0000',
  accent:            '#85C1A6',
  error:             '#FF7474',
  info:              '#85C1A6',
  success:           '#57BC82',
  warning:           '#F9F0E4',
  lightGrey:         '#FAFAFA',
  mediumGrey:        '#DDDDDD',
  darkPrimarySCA:    '#367551',
  primarySCA:        '#3D845C',
  lightPrimarySCA:   '#DEEDE4',
  developerSCA:      '#FFA500',
  administratorSCA:  '#798f8c',
  darkSecondarySCA:  '#367551',
  secondarySCA:      '#3D845C',
  lightSecondarySCA: '#44986B',
  boardColor1:       '#85C1A6',
  boardColor1Dark:   '#78A893',
  boardColor1Light:  '#DCECE5',
  boardColor2:       '#44986B',
  boardColor2Dark:   '#42855F',
  boardColor2Light:  '#C9E0D3',
  boardColor3:       '#587370',
  boardColor3Dark:   '#4E6562',
  boardColor3Light:  '#CED5D4',
  boardColor4:       '#70938E',
  boardColor4Dark:   '#64817D',
  boardColor4Light:  '#D5DFDD',
  boardColor5:       '#CCA38E',
  boardColor5Dark:   '#B18F7E',
  boardColor5Light:  '#EFE4DE',
  boardColor6:       '#AA6543',
  boardColor6Dark:   '#93593E',
  boardColor6Light:  '#E5D1C8',
  boardColor7:       '#367551',
  boardColor7Dark:   '#346648',
  boardColor7Light:  '#C5D6CB',
};

export default theme;
export { colors };



// WEBPACK FOOTER //
// ./src/theme.ts